import { render, staticRenderFns } from "./compRecordConfig.vue?vue&type=template&id=6196e66d&"
import script from "./compRecordConfig.vue?vue&type=script&lang=js&"
export * from "./compRecordConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports